import { z } from 'zod'

import {
  OrganizationIdSchema,
  OrganizationTypeSchema,
  PartnerProgramKindSchema,
  TeamIdSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { PrivilegeKeySchema } from './models.ts'

export const AuthorizationSchema = z.object({
  privileges: PrivilegeKeySchema.array(),
  teamIds: z.array(TeamIdSchema),
  organizationId: OrganizationIdSchema,
  organizationType: OrganizationTypeSchema,
  isSystem: z.boolean().optional(),
  isActive: z.boolean(),
  partnerPrograms: PartnerProgramKindSchema.array(),
})

export type Authorization = ZodInfer<typeof AuthorizationSchema>
